import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { AdminNextPage } from '../admin-next/admin-next';
import { Seva, Maasa, Paksha, Tithi } from '../../models/Seva';
import { RestProvider } from '../../providers/rest/rest';
import { Nakshatra } from '../../models/Seva';
import { Sevacategorty } from '../../models/PostLogin';


@IonicPage()
@Component({
  selector: 'page-admin',
  templateUrl: 'admin.html',
})
export class AdminPage implements OnInit{
//button_selected:string;
//new design
// admin_phone_number:number;
// admin_password:string;
new_seva_name:string;
new_seva_amount:number;
new_seva_persons:number;
new_seva_active:number = 1;
new_seva_online:boolean = true;
new_seva_online_limit:number;
new_seva_offline:boolean = true;
new_seva_offline_limit:number;
new_seva_section:string;
show_sections:boolean = false;
show_category:boolean = false;
new_seva_category:string;
new_seva_category_created:string;
new_seva_masa:any;
new_seva_paksha:any;
new_seva_tithi:any;
new_seva_nakshatra:any;
Sections_array:string[] = [];
Category_array:string[] = [];
//Maasa_array:Maasa[];
Maasa_array:any;
// Paksha_array:Paksha[];
Paksha_array:any;
// Tithi_array:Tithi[];
Tithi_array:any;
// Nakshatra_array:Nakshatra[];
Nakshatra_array:any;
seva_for_editing:Seva;
new_seva_alldays:boolean = true;
new_seva_monday:boolean = false;
new_seva_tuesday:boolean = false;
new_seva_wednusday:boolean = false;
new_seva_thursday:boolean = false;
new_seva_friday:boolean = false;
new_seva_saturday:boolean = false;
new_seva_sunday:boolean = false;
show_maasa:boolean = false;
show_nakshatra:boolean = false;
show_thithi:boolean = false;
show_paksha:boolean = false;
seva_days:any = [];
stype:string;





  constructor(public navCtrl: NavController, public navParams: NavParams,private alertCtrl:AlertController, private restProvider:RestProvider) {
  }
ngOnInit()
{
  this.Maasa_array = [];
  this.Paksha_array = [];
  this.Tithi_array = [];
  this.Nakshatra_array = [];
  this.seva_for_editing = this.navParams.get('sevaforedit');
  console.log("seva for editing:",this.seva_for_editing);
  if(this.navParams.get('stype'))
  {
    this.stype = this.navParams.get('stype')
    console.log(this.stype);
  }
  if(this.seva_for_editing)
  {
    this.restProvider.getSevaDetail(this.seva_for_editing.id).subscribe(
      (result) => {
       console.log(result);
       if(result)
       {
        this.new_seva_name = result.sevaname;
        this.new_seva_amount = result.seva_amount;
        this.new_seva_persons = result.persons_included;
        this.new_seva_active = (result.is_active == 1) ? 1 : 0;
        console.log(this.new_seva_amount,this.new_seva_persons,this.new_seva_active)
        this.new_seva_offline_limit = result.counter_booking_limit;
        this.new_seva_offline = (result.counter_booking_limit == 0) ? true : false;
        this.new_seva_online_limit = result.online_booking_limit;
        this.new_seva_online = (result.online_booking_limit == 0) ? true : false;
        this.new_seva_alldays = (result.weekdays == null) ? true : false;
        this.Category_array = result.sevacategory_data;
        this.Maasa_array = result.maasa_data;
        this.Nakshatra_array =result.nakshatra_data;
        this.Paksha_array = result.paksha_data;
        this.Tithi_array = result.tithi_data;
        console.log(this.Maasa_array);
        console.log("tithi array:",this.Tithi_array);
        if(result.sevacategory)
        {
          this.new_seva_category = result.sevacategory_data[result.sevacategory -1].description;
        }
         
        // this.new_seva_masa = result.maasa_data[0].name;
        // this.new_seva_paksha = result.paksha_data[0].name;
        // this.new_seva_nakshatra = result.nakshatra_data[0].name;
        // this.new_seva_tithi = result.tithi_data[0].name;


       }
      },
      error => {
        console.log(error);
        
      }
    )
    

  }
  else
  {
    this.restProvider.getSevaDetail(0).subscribe(
      (result) => {
       console.log(result);
       if(result)
       {
        this.new_seva_name = result.sevaname;
        this.new_seva_amount = result.sevaamount;
        this.new_seva_persons = result.personsincluded;
        //this.new_seva_active = (result.is_active == 1) ? 1 : 0;
        this.new_seva_offline_limit = result.counter_booking_limit;
        //this.new_seva_offline = (result.counter_booking_limit == 0) ? true : false;
        this.new_seva_online_limit = result.online_booking_limit;
        //this.new_seva_online = (result.online_booking_limit == 0) ? true : false;
        //this.new_seva_alldays = (result.weekdays == null) ? true : false;
        this.Maasa_array = result.maasa_data;
        this.Nakshatra_array =result.nakshatra_data;
        this.Paksha_array = result.paksha_data;
        this.Tithi_array = result.tithi_data;
        this.Category_array = result.sevacategory_data;
        
        console.log(this.Maasa_array);
        console.log("tithi array:",this.Tithi_array);
       
        //defaulting to first item of the array
        // this.new_seva_category = result.sevacategory_data[0].description;
        // this.new_seva_masa = result.maasa_data[0].name;
        // this.new_seva_paksha = result.paksha_data[0].name;
        // this.new_seva_nakshatra = result.nakshatra_data[0].name;
        // this.new_seva_tithi = result.tithi_data[0].name;



       }
      },
      error => {
        console.log(error);
      }
    )
  }
  this.Sections_array = ['REGULAR','SPECIAL','ARADHANA','BUILDING FUND'];
  this.Category_array = ['REGULAR','HUNDI','ARADHANA','SEASONAL','SWAMIJIGALU','BUILDING FUND','OTHERS'];

}
//new design functionality
Cancel()
{
  this.new_seva_name = null;
  this.new_seva_amount = null;
  this.new_seva_persons = null;
  this.new_seva_active = null;
  this.new_seva_online = false;
  this.new_seva_online_limit = null;
  this.new_seva_offline = false;
  this.new_seva_offline_limit = null;
  this.new_seva_section = null;
  this.new_seva_category = null;
  this.navCtrl.push(AdminNextPage,{stype:this.stype});
}
GoToAdminNextPage()
{
  //save has to be done before moving to other page
  let sevaobj = new Seva();
  sevaobj.sevaname = this.new_seva_name;
  sevaobj.sevaamount = this.new_seva_amount;
  sevaobj.persons_included = this.new_seva_persons;
  sevaobj.is_active = (this.new_seva_active)? 1 : 0;
  sevaobj.online_booking_limit = (this.new_seva_online == false) ? this.new_seva_online_limit : null;
  sevaobj.counter_booking_limit = (this.new_seva_offline == false) ? this.new_seva_offline_limit : null;
  if(this.new_seva_monday)
  {
   this.seva_days.push(1);
  }
  if(this.new_seva_tuesday)
  {
   this.seva_days.push(2);
  }
  if(this.new_seva_wednusday)
  {
   this.seva_days.push(3);
  }
  if(this.new_seva_thursday)
  {
   this.seva_days.push(4);
  }
  if(this.new_seva_friday)
  {
   this.seva_days.push(5);
  }
  if(this.new_seva_saturday)
  {
   this.seva_days.push(6);
  }
  if(this.new_seva_sunday)
  {
   this.seva_days.push(7);
  }
  // if(this.new_seva_alldays)
  // {
  // sevaobj.weekdays = null;
  // }
  //sevaobj.weekdays = (this.new_seva_alldays)? null :this.seva_days;
  
  console.log(sevaobj.weekdays);
  sevaobj.maasa = (this.new_seva_masa) ? this.new_seva_masa : null;
  sevaobj.paksha = (this.new_seva_paksha) ? this.new_seva_paksha : null;
  sevaobj.tithi = (this.new_seva_tithi) ? this.new_seva_tithi : null;
  sevaobj.nakshatra = (this.new_seva_nakshatra) ? this.new_seva_nakshatra : null;
  //category needs to be added
  sevaobj.sevacategory = (this.new_seva_category) ? this.new_seva_category : this.new_seva_category_created;
  
  sevaobj.id =(this.seva_for_editing) ? this.seva_for_editing.id : null;
  console.log("seva before posting:",sevaobj)
  if(sevaobj != null)
  {
    this.restProvider.postSevaDetail(sevaobj).subscribe(
      (result) => {
       console.log(result);
       if(result)
       {
          console.log(result);
          let alert = this.alertCtrl.create({
            title: 'Alert',
            subTitle: 'Seva created successfully',
            cssClass: 'buttonCss',
            buttons: [
              {
                text: 'Ok',
                cssClass: 'buttonCss',
                role: 'cancel',
                handler: () => {
                }
              }
            ]
          });
    
          alert.present();
    
          this.navCtrl.push(AdminNextPage,{stype:this.stype});
  
  
       }
      },
      error => {
        console.log(error);
        let alert = this.alertCtrl.create({
          title: 'Alert',
          subTitle: 'Seva not created',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
  
      }
    )
  }
  
  
  
}
showSectionsList()
{
  this.show_sections = true;
}
showCategoryList()
{
  this.show_category = !this.show_category;
}
setSection(section:any)
{
  this.new_seva_section = section;
  this.show_sections = false;
}
setCategory(category:Sevacategorty)
{
this.new_seva_category = category.description;
this.show_category = false;
}
hideList(){
  this.show_category = false;
}
clearCategory()
{
  this.new_seva_category_created = null;
}
showMaasaList()
{
this.show_maasa = true;
console.log(this.Maasa_array);
}
showTithiList()
{
  this.show_thithi = true;
  console.log(this.Tithi_array);
}
showPakshaList()
{
  this.show_paksha = true;
  console.log(this.Paksha_array);
}
showNakshatraList()
{
  this.show_nakshatra = true;
  console.log(this.Nakshatra_array);
}
setMaasa(s:Maasa)
{
  if(s)
  {
    this.show_maasa = false;
    this.new_seva_masa = s.name;
  }

} 
setPaksha(p:Paksha)
{
  if(p)
  {
    this.show_paksha = false;
    this.new_seva_paksha = p.name;
  }
  
}
setTithi(t:Tithi)
{
  if(t)
  {
    this.show_thithi = false;
    this.new_seva_tithi = t.name;
  }
  
}
setNakshatra(n:Nakshatra)
{
  if(n)
  {
    console.log("nakshatra",n)
    this.show_nakshatra = false;
    this.new_seva_nakshatra = n.name;
  }
  
}
 
}



// WEBPACK FOOTER //
// ./src/pages/admin/admin.ts